import { MouseEvent } from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  color: #fff;
  background-color: #000;
  padding: 6px 10px;
  border-radius: 4px;
  border: 0;
`;

type ButtonPropTypes = {
  children: React.ReactNode;
  onClick: (event?: MouseEvent<HTMLButtonElement>) => void;
};

export default function Button({ children, onClick }: ButtonPropTypes) {
  return <StyledButton onClick={onClick}>{children}</StyledButton>;
}
